import React, { useState, useEffect } from "react";

const Pagination = ({ postsPerPage, totalPosts, paginate }) => {
  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
    pageNumbers.push(i);
  }

  const [currentButton, setCurrentButton] = useState(1);
  const [arrOfCurrentButton, setArrCurrentButton] = useState([]);

  useEffect(() => {
    let tempNumberOfPages = [...pageNumbers];
    tempNumberOfPages = tempNumberOfPages.slice(0, 4);
    setArrCurrentButton(tempNumberOfPages);
  }, [currentButton]);

  console.log(arrOfCurrentButton);
  return (
    <div className="container max-w-[1200px] mx-auto">
      <div className="mb-12 ">
        <div className="c-paging mx-auto p-4 font1">
          <div
            onClick={() =>
              setCurrentButton((prev) => (prev === 1 ? prev : prev - 1))
            }
            className="inline-block w-8 h-8 leading-loose font-black text-center align-middle fa"
          >
            
          </div>
          {arrOfCurrentButton.map((number) => (
            <>
              <a
                onClick={() => {
                  setCurrentButton(number);
                  paginate(number);
                }}
                className={
                  currentButton === number
                    ? "inline-block w-8 h-8 leading-loose font-medium text-center align-middle text-white bg-blueLink rounded-full "
                    : "inline-block w-8 h-8 leading-loose font-medium text-center align-middle text-blueLink "
                }
              >
                {number}
              </a>
            </>
          ))}
          {/* <a
        href="#"
        className="inline-block w-8 h-8 leading-loose text-blueLink font-medium text-center align-middle"
      >
        2
      </a>
      <a
        href="#"
        className="inline-block w-8 h-8 leading-loose text-blueLink font-medium text-center align-middle"
      >
        3
      </a>
      <a
        href="#"
        className="inline-block w-8 h-8 leading-loose text-blueLink font-medium text-center align-middle"
      >
        4
      </a>
      <a
        href="#"
        className="inline-block w-8 h-8 leading-loose text-blueLink font-medium text-center align-middle"
      >
        5
      </a>
      <a
        href="#"
        className="inline-block w-8 h-8 leading-loose text-blueLink font-medium text-center align-middle"
      >
        6
      </a>
      <a
        href="#"
        className="inline-block w-8 h-8 leading-loose text-blueLink font-medium text-center align-middle"
      >
        7
      </a>
      <div className="inline-block w-8 h-8 leading-loose text-black font-medium text-center align-middle">
        ...
      </div>
      <a
        href="#"
        className="inline-block w-8 h-8 leading-loose text-blueLink font-medium text-center align-middle"
      >
        99
      </a> */}
          <a
            onClick={
              () =>
                setCurrentButton((next) =>
                  next === pageNumbers.length ? next : next + 1
                )
              //   setCurrentButton((next) =>
              //     next === pageNumbers.length
              //       ? paginate(next)
              //       : paginate(next + 1)
              //   );
            }
            className="inline-block w-8 h-8 leading-loose text-blueLink font-medium text-center fa align-middle"
          >
            
          </a>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
